import { Theme } from '../../../../types/shared'
import {
  ChartEventBadgeState,
  IChartEventBadgeProps,
  getChartEventBadgeColors,
  getChartEventBageColors,
} from '../utils'

export function getChartEventSplitSvgString({
  theme = Theme.light,
  state = ChartEventBadgeState.default,
  width,
}: IChartEventBadgeProps) {
  const { outerStroke, innerStroke, innerFill, textFill } = getChartEventBadgeColors({
    theme,
    state,
    colors: getChartEventBageColors('violet'),
  })

  // browsers have issue rendering non-straight paths when one have same edge as other,
  // outer stroke line edge is same as inner fill edge and when browser rasterize diagonal line it breaks it down to pixels with variable opacity/color
  // but if there aren't opacity pixels on same place render is correct, due that adding fill solve incorrect color of colliding opacity pixels
  return `
    <svg
      xmlns="http://www.w3.org/2000/svg"
      classname='pointer-events-none block'
      width="${width}"
      height="${width}"
      viewBox="0 0 24 24"
    >
      <rect x="1.5" y="1.5" width="21" height="21" rx="10.5" stroke="${outerStroke}" fill="${outerStroke}" />
      <rect x="3" y="3" width="18" height="18" rx="9" fill="${innerFill}" />
      <rect x="3" y="3" width="18" height="18" rx="9" stroke="${innerStroke}" fill="transparent" stroke-width="2" />

      <path
        d="M13.72 9.57c-.05-.4-.23-.72-.56-.94a2.16 2.16 0 0 0-1.25-.34c-.36 0-.67.06-.93.17-.26.11-.46.27-.6.46-.15.2-.22.42-.22.66 0 .21.05.39.15.54.1.15.22.28.38.38.17.1.34.18.52.25.19.07.37.12.54.16l.85.22c.28.07.56.16.85.28.3.12.57.27.82.46a2.05 2.05 0 0 1 .84 1.72c0 .5-.13.93-.39 1.31-.25.39-.62.7-1.1.91-.48.22-1.06.33-1.74.33-.66 0-1.22-.1-1.7-.3-.48-.21-.85-.5-1.12-.89a2.56 2.56 0 0 1-.45-1.36h1.32c.03.31.13.58.31.79.18.2.41.36.7.46.28.1.6.15.93.15.37 0 .7-.06 1-.17.28-.12.51-.29.68-.5.17-.21.25-.46.25-.74a.92.92 0 0 0-.22-.64c-.14-.16-.34-.3-.59-.4a5.8 5.8 0 0 0-.84-.3l-1.03-.28a4.02 4.02 0 0 1-1.66-.84c-.4-.36-.61-.85-.61-1.46 0-.5.13-.94.4-1.32.28-.37.65-.66 1.12-.87.46-.21.99-.32 1.57-.32.6 0 1.11.1 1.57.31.45.21.8.5 1.07.86.26.36.4.78.4 1.25h-1.26Z"
        fill="${textFill}"
      />
    </svg>
  `
}
